// The country the "Local" pages cover; every other country is "Global".
export const LOCAL_COUNTRY = process.env.REACT_APP_LOCAL_COUNTRY || "Nigeria";

export const isLocalCountry = (name) => !!name && name.toLowerCase().includes(LOCAL_COUNTRY.toLowerCase());
